import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const PencilCircle: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6859 5.31416C10.4763 5.10453 10.2024 5 9.92781 5C9.65334 5 9.37932 5.10453 9.16968 5.31416L5.37902 9.10439L5 11L6.89528 10.621L10.6859 6.83032C11.1047 6.41153 11.1047 5.73286 10.6859 5.31416Z"
      fill="currentColor"
    />
    <path
      d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
